import React from 'react';
import { Space, Text } from '@cashfree-intl/coherent';

import CustomIcon from '../../../components/CustomIcons';

const SignupBanner = () => (
  <Space
    direction="column"
    className="signup-banner"
    justifyContent="space-between"
  >
    <div className="upper-section">
      <Text variant="h28" strong>
        Why Choose Us?
      </Text>
      <div>
        <div className="heading">8,00,000+</div>
        <div className="description">
          Businesses trust us with their payment needs
        </div>
      </div>
      <div>
        <div className="heading">180+</div>
        <div className="description">Payment modes for smoother payments</div>
      </div>
      <div>
        <div className="heading">100+</div>
        <div className="description">
          Currencies to grow your business globally
        </div>
      </div>
    </div>
    <div className="lower-section">
      <Space>
        <CustomIcon componentName="NYKAA" />
        <CustomIcon componentName="ZOMATO" />
        <CustomIcon componentName="CRED" />
      </Space>
      <Space>
        <CustomIcon componentName="IRCTC" />
        <CustomIcon componentName="DREAM11" />
        <CustomIcon componentName="DELHIVERY" />
      </Space>
    </div>
  </Space>
);

export default SignupBanner;
